const PREFIX = 'MESSAGE_' as const;

export const ADD_ONE = `${PREFIX}ADD_ONE` as const;
export const DISMISS_ONE = `${PREFIX}DISMISS_ONE` as const;
export const DISMISS_ALL = `${PREFIX}DISMISS_ALL` as const;
